import axios from "axios";
import { config } from "../../base/constant";
import { isJSON } from "../../base/utils";
import { LocalStorage } from "../../custom_hooks/localStorageKeys";
import { GetItemFromStorage } from "../../custom_hooks/useStorage";
import { ChatActions } from "../slices/chat_slice/chat_slice";

const headers = { headers: { "Content-Type": "application/json" } }

export const sendMessageToNLP_Sentimental = (body: any, dispatch: any) => {
    try {
        axios.post(
            `${config().NLP_DNS}/ccaas_agent_assist_sentiment_view`,
            body,
            headers
        )
            .then((res: any) => {
                if (res?.status === 200 && res?.data) {
                    dispatch(ChatActions.messageSentimental_socialmedia({
                        ...res?.data,
                        messageId: body.messageId,
                        landingPage: body.landingPage,
                    }))
                }
            })
            .catch((err) => {
                console.log(err)
            });
    } catch (error) {
        console.log(error)
    }
}

export const getSentimentalCustomer_chat = async (data: any, dispatch: any) => {
    try {
        const message = isJSON(data?.message) ? JSON.parse(data?.message) : (typeof data === 'object' ? data : null);
        const msg = message?.data || message?.message;
        const isCustomer = (message?.isCustomer === true || data?.isCustomer === true)
        const userDetails = GetItemFromStorage(LocalStorage.USER_DETAILS);

        if (!message || data?.isBot)
            return;

        const body = {
            "sessionId": data?.sessionId || '',
            "messageId": data?.messageId || data?.messageID,
            "query": isCustomer ? (msg || '') : '',
            "agent": !isCustomer ? (msg || '') : '',
            "channel": 'Chat',
            "domainid": Number(userDetails?.domainId),
            "channelType": '',
            "landingPage": 0
        };
        sendMessageToNLP_Sentimental(body, dispatch);
    } catch (error) {
        console.log(error);
    }
};

const getLastmsgSocialMedia = (jsonString: any) => {
    try {
        const data = JSON.parse(jsonString);
        const last = Array.isArray(data) ? data[data.length - 1] : data;

        if (last.userText?.message) {
            return ({
                isCustomer: true,
                message: last.userText.message
            })
        } else {
            return ({
                isCustomer: false,
                message: last.agentText.message
            })
        }

    } catch (error) {
        return {}
    }
}

export const getSentimentalCustomer_socialmedia = async (data: any, dispatch: any) => {
    try {

        if (!data) return;
        const res: any = getLastmsgSocialMedia(data?.Message)

        const msg = res?.message;
        if (!msg) return;

        const userDetails = GetItemFromStorage(LocalStorage.USER_DETAILS);
        const body = {
            "sessionId": data?.sessionId || '',
            "messageId": `${msg?.sendAt}`,
            "query": res?.isCustomer ? (msg?.message || '') : '',
            "agent": !res?.isCustomer ? (msg?.message || '') : '',
            "channel": 'Socialmedia',
            "domainid": Number(userDetails?.domainId),
            "channelType": '',
            "landingPage": 0
        };
        sendMessageToNLP_Sentimental(body, dispatch);

    } catch (error) {
        console.log("getSentimentalCustomer_socialmedia error", error);
    }
};

export const getSentimentalCustomer_Call = async (data: any, dispatch: any) => {
    try {

        console.log("getSentimentalCustomer_Call==>>>", data)
        const hasText = data?.message?.trim()?.replace(/<[^>]*>/g, '')?.replace(/&nbsp;/g, '')?.trim();
        if (data?.isBot || !hasText)
            return;

        const userDetails = GetItemFromStorage(LocalStorage.USER_DETAILS);
        const body = {
            "sessionId": data?.sessionId || '',
            "messageId": data?.sendAt ? `${data?.sendAt}` : '',
            "query": data?.isCustomer ? (hasText || '') : '',
            "agent": !data?.isCustomer ? (hasText || '') : '',
            "channel": 'Call',
            "domainid": Number(userDetails?.domainId),
            "channelType": '',
            "landingPage": 0
        };

        sendMessageToNLP_Sentimental(body, dispatch);
    } catch (error) {
        console.log(error);
    }
};
